// extracted by mini-css-extract-plugin
module.exports = {"ffh_box":"ffh_box-1fzs1oAW"};